module.exports = __webpack_public_path__ + "static/media/2026_WA-Footy-Lives-Here-Social.b9600be0.jpg";